import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Router } from "@angular/router";
import {
  fetchAffiliate,
  fetchAffiliateSuccess,
  fetchAffiliateFailure,
  getAffiliate,
  getAffiliateSuccess,
  getAffiliateFailure
} from "./affiliate.actions";
import { of } from "rxjs";
import { map, mergeMap, catchError, tap } from "rxjs/operators";
import { AffiliateService } from "@services/affiliate/affiliate.service";

@Injectable()
export class AffiliateEffects {
  
  loadAffiliate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchAffiliate),
      mergeMap(action =>
        this.affiliateService.getAffiliates(action.filterOptions).pipe(
          map(res => {
            return fetchAffiliateSuccess({ affiliate: res });
          }),
          catchError(error => {
            return of(fetchAffiliateFailure({ error }));
          })
        )
      )
    )
  );


  getAffiliate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getAffiliate),
      mergeMap(action => 
        this.affiliateService.getAffiliate(action.id).pipe(
          map(res => {
            return getAffiliateSuccess({ affiliate: res });
          }),
          catchError(error => {
            return of(getAffiliateFailure({ error }));
          })
        )
      )
    )
  );


  constructor(
    private actions$: Actions,
    private affiliateService: AffiliateService,
    private router: Router
  ) {}
}
